import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
    name: 'changeTimeZone',
    standalone: false
})
export class ChangeTimeZonePipe implements PipeTransform {

    /*
     * Change dateTime to user time zone and format into string for the view.
     *
     * @param dateTime Date to be changed
     * @param timeZone Disired Date end time zone
     *
     * @returns string of Date formated according to preferences, if dateTime is null return N/A string
     */
    transform(dateTime: Date, timeZone: string, format: string = 'MMMM D, YYYY h:mm:ss z'): string  {
        if (dateTime === null) {
            return 'N/A';
        }

        if (timeZone) {
            // Convert date into moment & adjust date based on the timezone
            const momentDate: moment.Moment = moment(dateTime)?.tz(timeZone);


            return momentDate.format(format);
        }

    }
}
